import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

const app = createApp(App);


/** Vconsole */
import Vconsole from 'vconsole'
if (process.env.VUE_APP_CURRENTMODE !== 'PROD') {
    app.use(new Vconsole());
}


/** Vant */
import Vant from 'vant';
import 'vant/lib/index.css';
// import PopupLoading from "./plugins/popupLoading";


app.use(Vant);
// app.use(PopupLoading);

/** api */
import {api} from '@/api/api';
import { initAuthStorage, getAuthUserInfo } from '@/utils/authStorage'

app.config.globalProperties.$api = api;
api.baseUrlList = process.env.VUE_APP_BASEURLLIST;

// 进入应用：从原生恢复登录态（换域名后 localStorage 可能为空），并回写原生
initAuthStorage()
const restoredUserInfo = getAuthUserInfo()
if (restoredUserInfo?.merchantId) {
    api.params.merchantId = restoredUserInfo.merchantId;
}

if (process.env.VUE_APP_CURRENTMODE !== 'PROD') {
    app.provide('SDK_APP_ID', 'sdkqiangdanya')
    app.provide('SDK_APP_SECRET', '3hu25dzm2vpq7v691u1oo0eo4am79ks7')
}else{
    app.provide('SDK_APP_ID', 'sdkqiangdanya')
    app.provide('SDK_APP_SECRET', 'wp782865my99iysa6gnubzk6kvfycg36')

}


app.use(store).use(router).mount('#app')
